import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { thirdPartyCrDisclaimer } from "../../utils/constants/disclaimers";
import { getConfig } from "../../utils/helpers";

const linkStyleDefault = {
  color: '#4183c4',
}

/** 
 * Acknowledgement checkbox of 3rd Party Condition Report, if it exists
 * @param {{crLink?: string, crType?: '4' | '5', onAgreeChange: ()=>void, linkStyle?: React.CSSProperties}} props
 * @returns {React.JSX | null} 
 */
function ThirdPartyCrAgree ({crLink, crType, isChecked, onAgreeChange, linkStyle=linkStyleDefault}) {
    if (
        !crLink || !(crType && ['4', '5'].includes(crType)) || getConfig('ignoreThirdPartyCrAgree') === true
    ) {
        return null
    };
     
    return (
      <div className='form-group'>
        <input
          type="checkbox"
          id="cr-disclaimer-agree"
          checked={isChecked}
          onChange={onAgreeChange}
        />
        <label htmlFor="cr-disclaimer-agree" style={{ marginLeft: 5, color: '#787878' }}>
            {thirdPartyCrDisclaimer.ACKNOWLEDGE}
            {" "}
            <a
              href={crLink}
              target="_blank"
              rel="noreferrer"
              style={linkStyle}
            >
              {thirdPartyCrDisclaimer.LINK_TEXT}
            </a>
        </label>
      </div>
    )
    
}

export {ThirdPartyCrAgree};